<template>
  <v-list class="py-0"
          color="secondary"
          dark>
    <v-subheader>{{ $t('discover') }}</v-subheader>

    <v-list-item color="accent"
                 exact
                 v-bind:to="{ name: 'home' }">
      <v-list-item-icon>
        <v-icon>mdi-map-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('map') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item color="accent"
                 exact
                 v-bind:to="{ name: 'spots' }">
      <v-list-item-icon>
        <v-icon>mdi-fire</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('ourSpots') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item color="accent"
                 exact
                 v-bind:to="{ name: 'list' }">
      <v-list-item-icon>
        <v-icon>mdi-truck</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('ourTrucks') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item color="accent"
                 exact
                 v-bind:to="{ name: 'partner-list' }">
      <v-list-item-icon>
        <v-icon>mdi-handshake</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('ourPartners') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider />

    <v-subheader>{{ $t('contact') }}</v-subheader>

    <v-list-item target="_blank"
                 v-bind:href="webUrl">
      <v-list-item-icon>
        <v-icon>mdi-web</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('web') }}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon color="grey"
                small>
          mdi-open-in-new
        </v-icon>
      </v-list-item-action>
    </v-list-item>

    <v-list-item target="_blank"
                 v-bind:href="instagramUrl">
      <v-list-item-icon>
        <v-icon>mdi-instagram</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('instagram') }}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon color="grey"
                small>
          mdi-open-in-new
        </v-icon>
      </v-list-item-action>
    </v-list-item>

    <v-list-item v-bind:href="`mailto:${email}`">
      <v-list-item-icon>
        <v-icon>mdi-email</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('email') }}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon color="grey"
                small>
          mdi-open-in-new
        </v-icon>
      </v-list-item-action>
    </v-list-item>

    <v-divider />

    <v-subheader>{{ $t('legal') }}</v-subheader>

    <v-list-item color="accent"
                 v-bind:to="{ name: 'licences' }">
      <v-list-item-icon>
        <v-icon>mdi-information</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('licences') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item color="accent"
                 v-bind:to="{ name: 'imprint' }">
      <v-list-item-icon>
        <v-icon>mdi-scale-balance</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('imprint') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item color="accent"
                 v-bind:to="{ name: 'privacy-policy' }">
      <v-list-item-icon>
        <v-icon>mdi-shield-account</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ $t('privacyPolicy') }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
 import settings from '@/settings'

  export default {
    computed: {
      email() {
        return settings.email
      },
      instagramUrl() {
        return settings.instagramUrl
      },
      webUrl() {
        return settings.webUrl
      }
    },
    name: 'PrimaryNavigation'
  }
</script>

<i18n>
  {
    "de": {
      "contact": "Kontakt",
      "discover": "Entdecken",
      "email": "E-Mail",
      "imprint": "Impressum",
      "instagram": "Instagram",
      "legal": "Rechtliches",
      "licences": "Lizenzen",
      "ourTrucks": "Unsere Trucks",
      "ourPartners": "Unsere Partner",
      "map": "Karte",
      "privacyPolicy": "Datenschutzerklärung",
      "ourSpots": "Unsere Spots",
      "web": "Webseite"
    },
    "en": {
      "contact": "Contact",
      "discover": "Discover",
      "email": "Email",
      "imprint": "Imprint",
      "instagram": "Instagram",
      "legal": "Legal",
      "licences": "Licences",
      "ourTrucks": "Our trucks",
      "ourPartners": "Our partners",
      "map": "Map",
      "privacyPolicy": "Privacy policy",
      "ourSpots": "Our Spots",
      "web": "Web"
    }
  }
</i18n>